import Vue from 'vue';
import SearchConfig from '@sun-chemical/system-config/search-config';
import * as types from './mutation-types';

export default {
  [types.SET_RESULTS](state, results) {
    state.results = results;
  },
  [types.SET_URL_FILTERS](state, filters) {
    state.urlFilters = filters;
  },
  [types.SET_ACTIVE_DROPDOWN_FILTER](state, filter) {
    state.activeDropDownFilter = filter;
  },
  [types.SET_SEARCH_TERM](state, term) {
    Vue.set(state.urlFilters, SearchConfig.getMap().search_term.param, term);
  },
  [types.ADD_RESULTS](state, results) {
    state.results.hits = state.results.hits.concat(results);
  },
  [types.SET_LOADING_STATE](state, loadingState) {
    state.isLoading = loadingState;
  },
  [types.SET_MOBILE_FILTER_BAR_VISIBILITY](state, visible) {
    state.mobileFilterBarVisible = visible;
  }
};
